__turbopack_context__.v({
  "blobAmber": "ohRx6a_blobAmber",
  "blobPrimary": "ohRx6a_blobPrimary",
  "charge-up": "ohRx6a_charge-up",
  "chargeBar": "ohRx6a_chargeBar",
  "entrance": "ohRx6a_entrance",
  "entrance-up": "ohRx6a_entrance-up",
  "entranceDelay1": "ohRx6a_entranceDelay1",
  "entranceDelay2": "ohRx6a_entranceDelay2",
  "entranceDelay3": "ohRx6a_entranceDelay3",
  "entranceDelay4": "ohRx6a_entranceDelay4",
  "finalSection": "ohRx6a_finalSection",
  "float-y": "ohRx6a_float-y",
  "floatFast": "ohRx6a_floatFast",
  "floatSlow": "ohRx6a_floatSlow",
  "floatSlower": "ohRx6a_floatSlower",
  "glow-pulse": "ohRx6a_glow-pulse",
  "glowPulse": "ohRx6a_glowPulse",
  "hero": "ohRx6a_hero",
  "heroAmbient": "ohRx6a_heroAmbient",
  "heroAmbientAmber": "ohRx6a_heroAmbientAmber",
  "heroAmbientPrimary": "ohRx6a_heroAmbientPrimary",
  "heroDots": "ohRx6a_heroDots",
  "marquee": "ohRx6a_marquee",
  "marquee-x": "ohRx6a_marquee-x",
  "pop-in": "ohRx6a_pop-in",
  "popIn": "ohRx6a_popIn",
  "productsSection": "ohRx6a_productsSection",
  "ring-ping": "ohRx6a_ring-ping",
  "sparePartsSection": "ohRx6a_sparePartsSection",
  "successRing": "ohRx6a_successRing",
});
